import Logo from '../multimedia/logo.png'
import { Link } from 'react-router-dom'
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons'
import NavItem from '../components/NavItem'
import NavItem2 from '../components/NavItem2'
import {
    Box,
    Flex,
    HStack,
    IconButton,
    Menu,
    Image,
    useColorModeValue,
    Stack,
    useDisclosure,
    MenuButton,
} from '@chakra-ui/react'
import SV from '../multimedia/icons/sv.png'

const Navbar = (props) => {

    const { isAuth, client, logout } = props
    const { isOpen, onOpen, onClose } = useDisclosure()
    return (
        <Box bg={useColorModeValue('white', 'white.900')} px={4}>
            <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
                <IconButton
                    size={'md'}
                    icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
                    aria-label={'Open Menu'}
                    display={{ lg: 'none' }}
                    onClick={isOpen ? onClose : onOpen}
                />
                <Link to={"/"}><Image src={Logo} w={"auto"} h={"40px"} /></Link>
                <Flex alignItems={'center'} display={{ base: 'none', lg: 'flex' }}>
                    <HStack as={'nav'} display={{ base: 'none', lg: 'flex' }}>
                        <NavItem path={"/"}>Inicio</NavItem>
                        <NavItem path={"/cars"}>Catálogo</NavItem>
                        <NavItem path={"/requisitos"}>¿Cómo adquirirlo?</NavItem>
                        {/*
                        <NavItem path={"/vende"}>Vende tu vehículo</NavItem>    
                        */}
                        <NavItem path={"/nosotros"}>Nosotros</NavItem>
                        <NavItem path={"/puntos-pago"}>Puntos de pagos</NavItem>
                        <NavItem path={"/blog"}>Blog</NavItem>
                        <Menu>
                            <MenuButton>
                                <Image src={SV} w={"auto"} h={"40px"} />
                            </MenuButton>
                        </Menu>
                    </HStack>
                    
                </Flex>
            </Flex>
            {isOpen ? (
                <Box pb={4} display={{ lg: 'none' }}>
                    <Stack as={'nav'} spacing={4}>
                        <NavItem path={"/"}> Inicio</NavItem>
                        {isAuth ?
                            <div>
                                <NavItem path={"/profile"}>Perfil</NavItem>
                                <NavItem path={"/profile/documents"}>Mis documentos</NavItem>
                                <NavItem path={"/status"}>Solicitudes</NavItem>
                            </div>
                            :
                            <NavItem path={"/login"} color={"verde"}>Iniciar sesión</NavItem>
                        }
                        <NavItem path={"/cars"}>Compra tu vehículo</NavItem>
                        <NavItem path={"/requisitos"}>Paga a cuotas</NavItem>
                        <NavItem path={"/puntos-pago"}>Puntos de pagos</NavItem>
                        <NavItem path={"/experiencia-easycar"}>Experiencia EASYCAR</NavItem>
                        <NavItem path={"/blog"}>Blog</NavItem>
                        {isAuth &&
                            <NavItem2 onClick={logout}>Cerrar sesión</NavItem2>
                        }
                    </Stack>
                </Box>
            ) : null}
        </Box>
    )
}

export default Navbar

//<NavItem path={"/bolsa-empleo"}>Trabaja con nosotros</NavItem>